import { makeStyles } from "@mui/styles";

const dotLoadingAnimation = (theme) => ({
  to: {
    transform: "translateY(-5px)",
    color: theme.palette.primary.main, // Add any additional styling as needed
  },
});

export const useStyles = makeStyles((theme) => ({
  dotLoading: {
    height: "8px",
    borderRadius: "50%",
    background: theme.palette.tertiary.smartSearchUserText,
    animation: "$dotLoading 0.6s infinite alternate",
    width: "8px",
  },
  dotLoadingContainer: {
    "& > div:nth-child(2)": {
      animationDelay: "0.2s",
    },
    "& > div:nth-child(3)": {
      animationDelay: "0.4s",
    },
  },
  "@keyframes dotLoading": dotLoadingAnimation(theme),
  selectedIcons: {
    cursor: "pointer",
    color: theme.palette.secondary.main,
    fontSize: theme.size[20],
  },
  outlinedIcons: {},
  divCenterAlign: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  filledButton: {
    padding: "0px 20px",
    height: theme.size[35],
    minWidth: theme.size[100],
    boxShadow: theme.boxShadow,
    border: `${theme.size[1]} solid ${theme.palette.button.background}`,
    backgroundColor: theme.palette.button.background,
    zIndex: "99",
    color: theme.palette.button.text,
    fontSize: theme.size[12],
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.button.background,
      color: theme.palette.button.text,
    },
    "&:disabled": {
      opacity: "0.5",
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[900],
      border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
    },
  },

  disabledButton: {
    padding: "0px 20px",
    minWidth: theme.size[100],
    height: theme.size[35],
    boxShadow: theme.boxShadow,
    zIndex: "99",
    fontSize: theme.size[12],
    textTransform: "none",
    cursor: "not-allowed",
    opacity: "0.5",
    borderRadius: theme.size[5],
    // border: `${theme.size[1]} solid ${theme.palette.secondary.main}`,
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.grey[900],
    border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
    "&:hover": {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[900],
    },
  },

  outlinedButton: {
    padding: "0px 20px",
    minWidth: theme.size[100],
    height: theme.size[35],
    boxShadow: theme.boxShadow,
    border: `${theme.size[1]} solid ${theme.palette.primary.main}`,
    zIndex: "99",
    color: theme.palette.primary.main,
    fontSize: theme.size[12],
    textTransform: "none",
    "&:disabled": {
      opacity: "0.5",
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[900],
      border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
    },
  },
  filledButtonSmall: {
    padding: "0px 20px",
    minWidth: theme.size[100],
    height: theme.size[30],
    boxShadow: theme.boxShadow,
    border: `${theme.size[1]} solid ${theme.palette.button.background}`,
    backgroundColor: theme.palette.button.background,
    color: theme.palette.button.text,
    fontSize: theme.size[12],
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.button.background,
      color: theme.palette.button.text,
    },
    "&:disabled": {
      opacity: "0.5",
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[900],
      border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
    },
  },
  purpleFilledButton: {
    padding: "0px 20px",
    height: theme.size[35],
    minWidth: theme.size[100],
    boxShadow: theme.boxShadow,
    border: `${theme.size[1]} solid ${theme.palette.tertiary.smartSearchNewChat}`,
    backgroundColor: theme.palette.tertiary.smartSearchNewChat,
    zIndex: "99",
    color: theme.palette.button.text,
    fontSize: theme.size[12],
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.tertiary.smartSearchNewChat,
      color: theme.palette.button.text,
    },
    "&:disabled": {
      opacity: "0.5",
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[900],
      border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
    },
  },
  outlinedButtonSmall: {
    minWidth: theme.size[100],
    padding: "0px 20px",
    height: theme.size[30],
    boxShadow: theme.boxShadow,
    border: `${theme.size[1]} solid ${theme.palette.tertiary.darkBlue}`,
    color: theme.palette.tertiary.darkBlue,
    fontSize: theme.size[12],
    textTransform: "none",
    "&:disabled": {
      opacity: "0.5",
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[900],
      border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
    },
  },
  requiredAsterik: {
    color: theme.palette.asterik.main,
    padding: `${theme.size[0]} ${theme.size[2]}`,
  },
  goToBtn: {
    width: theme.size[100],
    height: theme.size[35],
    borderRadius: theme.size[5],
    boxShadow: theme.boxShadow,
    border: `${theme.size[1]} solid ${theme.palette.primary.main}`,
    color: theme.palette.tertiary.light,
    zIndex: "1000",
    fontSize: theme.size[13],
    fontWeight: theme.fontWeight[600],
    textTransform: "none",
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.tertiary.light,
    },
    "&:disabled": {
      opacity: "0.5",
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[900],
      border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
    },
  },
  headerStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  kpiBoxStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #E3E3E3",
    boxShadow: "0.5px 0.5px 2px 2px #E3E3E3",
    minWidth: theme.size[500],
    position: "relative",
    boxSizing: "border-box",
    flex: 1,
  },
  noResultFoundClass: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
}));

export const accountSetupStyles = makeStyles((theme) => ({
  container: {
    flex: 1,
    zIndex: 1000,
    padding: "0 80px",
    display: "flex",
    flexDirection: "column",
    gap: theme.sizeRem[1],
  },
  setupContainer: {
    backgroundColor: theme.palette.primary.backgroundColor,
    height: "calc(100vh - 0px)",
    boxSizing: "border-box !important",
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  setupSection: {
    height: "100vh",
    width: "100%",
  },
  setupCardContainer: {
    height: "100%",
    marginRight: "auto",
    position: "relative",
    zIndex: "10",
    boxSizing: "border-box",
    margin: "0px 0",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  setupCardContainerInner: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: "20",
    height: "100%",
    boxSizing: "border-box",
    backgroundColor: theme.palette.tertiary.lightSmoke,
    boxShadow: theme.boxShadow,
    borderRadius: theme.size[15],
    padding: "40px 0 50px 0",
  },
  geoBtnSelected: {
    border: `${theme.size[1]} solid ${theme.palette.optionsCard.hoverBackground} !important`,
    color: theme.palette.optionsCard.hoverText,
    background: theme.palette.optionsCard.hoverBackground,
    fontWeight: theme.fontWeight[500],
    fontSize: theme.size[12],
  },
  geoBtnUnselected: {
    color: theme.palette.optionsCard.text,
    background: theme.palette.optionsCard.background,
    fontWeight: theme.fontWeight[500],
    fontSize: theme.size[12],
    "&:hover": {
      background: theme.palette.signupButton.background,
    },
  },
  setupCardListJobContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    zIndex: "1000",
  },
  setupCardListJobContainerInner: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  setupCardListFunctionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    zIndex: "1000",
  },
  setupCardList: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  setupCard: {
    position: "relative",
    boxSizing: "border-box",
    borderRadius: theme.size[4],
    padding: "0 20px",
    height: theme.size[50],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    margin: theme.size[10],
    cursor: "pointer",
    width: "280px",
    zIndex: 20,
    border: `${theme.size[1]} solid ${theme.palette.optionsCard.border} !important`,
    color: theme.palette.optionsCard.text,
    background: theme.palette.optionsCard.background,
  },
  setupJobroleCard: {
    position: "relative",
    boxSizing: "border-box",
    borderRadius: theme.size[4],
    padding: theme.size[18],
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    margin: theme.size[10],
    cursor: "pointer",
    zIndex: 20,
    width: "280px",
    gap: "10px",
    height: theme.size[35],
    justifyContent: "space-between",
    border: `${theme.size[1]} solid ${theme.palette.optionsCard.border} !important`,
    color: theme.palette.optionsCard.text,
    background: theme.palette.optionsCard.background,
    "&:hover": {
      background: theme.palette.signupButton.background,
      color: theme.palette.optionsCard.hoverText,
      border: `${theme.size[1]} solid ${theme.palette.optionsCard.hoverBackground} !important`,
    },
  },
  setupCardSelected: {
    position: "relative",
    boxSizing: "border-box",
    borderRadius: theme.size[4],
    padding: "0 20px",
    height: theme.size[50],
    display: "flex",
    alignItems: "center",
    width: "280px",
    justifyContent: "center",
    flexDirection: "column",
    margin: theme.size[10],
    cursor: "pointer",
    border: `${theme.size[1]} solid ${theme.palette.optionsCard.border} !important`,
    color: theme.palette.optionsCard.hoverText,
    background: theme.palette.optionsCard.hoverBackground,
  },
  setupJobroleCardSelected: {
    position: "relative",
    border: `${theme.size[1]} solid ${theme.palette.optionsCard.hoverBackground} !important`,
    color: theme.palette.optionsCard.hoverText,
    background: theme.palette.optionsCard.hoverBackground,
    boxSizing: "border-box",
    borderRadius: theme.size[4],
    padding: theme.size[18],
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    margin: theme.size[10],
    cursor: "pointer",
    width: "280px",
    height: theme.size[35],
    gap: "10px",
  },
  setupCardIcon: {
    height: theme.size[28],
    left: "381px",
    marginRight: "25px",
  },
  setupCardHeading: {
    fontStyle: "normal",
    fontSize: theme.size[13],
    lineHeight: theme.size[18],
    textAlign: "center",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: theme.size[500],
  },
  setupCardSubheading: {
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: theme.size[12],
    lineHeight: theme.size[16],
    marginTop: theme.size[2],
    whiteSpace: "nowrap",
    width: "100%",
    textAlign: "center",
  },
  accountSetupButtonFilled: {
    width: theme.size[100],
    height: theme.size[35],
    borderRadius: theme.size[4],
    boxShadow: theme.boxShadow,
    zIndex: "1000",
    textTransform: "none",
    marginLeft: "20px !important",
    border: `${theme.size[1]} solid ${theme.palette.signupButton.border} !important`,
    color: theme.palette.signupButton.hoverText,
    background: theme.palette.signupButton.background,
    fontSize: theme.size[12],
    "&:hover": {
      cursor: "pointer",
      color: theme.palette.signupButton.hoverText,
      background: theme.palette.signupButton.background,
    },
    "&:disabled": {
      opacity: "0.5",
      // background: `${theme.palette.signupButton.background}99`,
      color: theme.palette.signupButton.hoverText,
      border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
    },
  },
  accountSetupButtonOutlined: {
    width: theme.size[100],
    height: theme.size[35],
    borderRadius: theme.size[4],
    boxShadow: theme.boxShadow,
    zIndex: "1000",
    textTransform: "none",
    border: `${theme.size[1]} solid ${theme.palette.signupButton.border} !important`,
    color: theme.palette.signupButton.text,
    background: theme.palette.signupButton.outlinedBackground,
    fontSize: theme.size[12],
    "&:hover": {
      cursor: "pointer",
      color: theme.palette.signupButton.hoverText,
      background: theme.palette.signupButton.background,
    },
  },
  iconVisibilityStepper: {
    display: "none",
  },
}));

export const welcomeScreenStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    flex: 1,
    zIndex: 1000,
    padding: "10px 70px",
    height: "100%",
    overflow: "auto",
  },
  BeginButton: {
    width: theme.size[140],
    height: theme.size[35],
    borderRadius: theme.size[4],
    boxShadow: theme.boxShadow,
    zIndex: "1000",
    textTransform: "uppercase",
    fontWeight: theme.fontWeight[600],
    fontSize: theme.size[12],
    color: theme.palette.button.text,
    backgroundColor: theme.palette.button.background,
    "&:hover": {
      color: theme.palette.button.text,
      backgroundColor: theme.palette.button.background,
    },
    "&:disabled": {
      opacity: "0.5",
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[900],
      border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
    },
  },
}));

export const rapidStyles = makeStyles((theme) => ({
  gridViewCard: {
    width: theme.size[315],
    height: theme.size[260],
    border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
    borderRadius: theme.size[5],
    padding: theme.size[10],
    gap: theme.size[30],
    margin: theme.size[5],
    cursor: "pointer",
    position: "relative",
  },
}));

export const brainStyles = makeStyles((theme) => ({
  tableHeader: {
    fontWeight: 700,
    fontSize: "0.68rem",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: theme.palette.brain.table.header.text,
    py: 1.2,
    px: 1.5,
    whiteSpace: "nowrap",
    borderBottom: `2px solid ${theme.palette.secondary.main2}`,
    background: theme.palette.brain.table.header.background,
  },
  restrictedHeader: {
    fontWeight: 700,
    fontSize: "0.68rem",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: theme.palette.brain.table.header.text,
    py: 1.2,
    px: 1.5,
    whiteSpace: "nowrap",
    background: theme.palette.brain.table.header.restrictedBackground,
    borderBottom: `2px solid ${theme.palette.brain.table.header.restrictedBackground}`,
  },
  baseCell: {
    py: 0.9,
    px: 1.25,
    fontSize: "0.8rem",
    borderBottom: `1px solid ${theme.palette.brain.mis.grey.border2}`,
  },
}));

export const harborStyles = makeStyles((theme) => ({
  tableHeader: {
    fontWeight: 700,
    fontSize: "0.68rem",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: theme.palette.harbor.table.header.text,
    py: 1.2,
    px: 1.5,
    whiteSpace: "nowrap",
    borderBottom: `2px solid ${theme.palette.secondary.main2}`,
    background: theme.palette.harbor.table.header.background,
  },
  restrictedHeader: {
    fontWeight: 700,
    fontSize: "0.68rem",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: theme.palette.harbor.table.header.text,
    py: 1.2,
    px: 1.5,
    whiteSpace: "nowrap",
    background: theme.palette.harbor.table.header.restrictedBackground,
    borderBottom: `2px solid ${theme.palette.harbor.table.header.restrictedBackground}`,
  },
  baseCell: {
    py: 0.9,
    px: 1.25,
    fontSize: "0.8rem",
    borderBottom: `1px solid ${theme.palette.harbor.mis.grey.border}`,
    borderRight: `1px solid ${theme.palette.harbor.grey.border}`,
  },
}));
